import {
  computeEffectiveEnvironmentCostValue,
  findStackById,
  selectEnvironmentsByOrgAsList,
  selectStacks,
} from "@app/deploy";
import { createSelector } from "@app/fx";
import { type WebState, schema } from "@app/schema";
import type { DeployEnvironment } from "@app/types";

export interface DeployEnvironmentRow extends DeployEnvironment {
  stackName: string;
  cost: number;
}

export const selectEnvironmentsForTable = createSelector(
  selectEnvironmentsByOrgAsList,
  selectStacks,
  schema.costs.selectTable,
  schema.costRates.select,
  (envs, stacks, costs, rates): DeployEnvironmentRow[] =>
    envs
      .map((env) => {
        const stack = findStackById(stacks, { id: env.stackId });
        const cost = computeEffectiveEnvironmentCostValue(costs, rates, env);
        return { ...env, stackName: stack.name, cost };
      })
      .sort((a, b) => b.id.localeCompare(a.id, undefined, { numeric: true })),
);

export const selectEnvironmentsByStackIdForTable = createSelector(
  selectEnvironmentsForTable,
  (_: WebState, props: { stackId: string }) => props.stackId,
  (rows, stackId): DeployEnvironmentRow[] =>
    rows.filter((r) => r.stackId === stackId),
);
